import { Buffer } from 'buffer';

import useCurrentToken from './useCurrentToken';

type Token = {
  adminUser?: string;
};

/**
 * Extract the adminUser field from token.
 *
 * This field is populated when an admin user impersonate another account.
 */
const useImpersonatedAdminUserId = (): string | undefined => {
  const [token] = useCurrentToken();

  if (token) {
    try {
      const { adminUser } = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString()) as Token;

      return adminUser;
    } catch (error) {
      return undefined;
    }
  }

  return undefined;
};

export default useImpersonatedAdminUserId;
